import { Outlet } from "@tanstack/react-router";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "./sidebar";
import { Topbar } from "./topbar";
import { VerifyEmailBanner } from "@/components/verify-email-banner";

// The sidebar writes its open/collapsed state to the `sidebar_state` cookie.
// This is a client SPA (no SSR), so read it once on mount to keep the user's
// collapse preference across reloads.
function initialSidebarOpen(): boolean {
  const m = document.cookie.match(/(?:^|;\s*)sidebar_state=([^;]+)/);
  return m ? m[1] !== "false" : true;
}

export function Shell() {
  return (
    <SidebarProvider defaultOpen={initialSidebarOpen()}>
      <AppSidebar />
      <SidebarInset className="relative flex min-w-0 flex-1 flex-col overflow-hidden">
        {/* faint brand glow anchored top-left of the workspace */}
        <div
          aria-hidden
          className="pointer-events-none absolute inset-x-0 top-0 -z-0 h-64 opacity-[0.05]"
          style={{
            background: "radial-gradient(60% 100% at 20% 0%, var(--brand) 0%, transparent 70%)",
          }}
        />
        <Topbar />
        <VerifyEmailBanner />
        <main className="scroll-thin relative z-10 flex-1 overflow-auto px-6 py-6">
          <div className="mx-auto max-w-[1400px]">
            <Outlet />
          </div>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
